import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { fuseAnimations } from '@fuse/animations';
import {TranslateService} from '@ngx-translate/core';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { WizardLeaderService } from 'app/main/wizard-leader/services/wizard.service';
import Swal from 'sweetalert2';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import * as $ from 'jquery';
import { ModalRecoComponent } from "./modal-reco/modal-reco.component";
import { SurveyCheckComponent } from "./survey-check/survey-check.component";
//SERVICE
import { SheduleService } from "../../services/shedule.service";
import {CountdownComponent} from 'ngx-countdown';
import { AuthService } from 'app/auth/auth.service';
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { LeaderEditEmaService } from 'app/main/wizard-leader/services/leaderEditEma.service';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
const momentTz = require('moment-timezone');

@Component({
  selector: 'vista-gen',
  templateUrl: './vista-gen.component.html',
  styleUrls: ['./vista-gen.component.scss'],
  animations   : fuseAnimations
})
export class VistaGenComponent implements OnInit {

  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @ViewChild('fecRecordatorio', { read: undefined }) calReco: MatDatepicker<Date>;
  // @ViewChild('cd', { static: false }) countdown: CountdownComponent;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;
  idEmpresa=localStorage.getItem('companyID');
  idProducto=localStorage.getItem('productoID');

  idiomaActual:string;
  instituto: number;

  cards= catalogo.cards;
  secciones = catalogo.secciones;

  logoOK: boolean;
  reqTecOK: boolean;

  idFechaLanzamiento: string;
  fechaLanzamiento: any;
  fechaCierre: any;
  fechaCierreValidacion: any;
  fechasRecordatorios: any[] = [];

  numSecciones = 0;
  seccionesCompletas = 0;
  indices:any[] = [];
  creandoEncuesta: boolean;
  tamanioTagSecc: number;
  progresoEncuesta = 0;
  procesoActual: string;
  procesoFinalizado: boolean;
  procesoOK = true;
  //variable que permite modifcar la fecha de cierre de la encuesta
  updateFechaCierre=false;


  filtroLanzamiento = (d: Date | null): boolean => {
    var moment = require('moment');
    return moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
  };
  filtroRecordatorios: any;
  prorrogasEncuesta:any;
  prorrogas=false;
  cierreEditable = false;
  token:any;
  datosSurveyCheck:any;

  configCD: any = {
    demand: true,
    format: 'HH:mm:ss',
    leftTime: 0
  }
  tiempoRestante = 0;

  recordatoriosPermitidos = 1000; //tomar de variable despues
  fechaRecoTemp: any;

  //zonas horarias
  zonasUTC = zonasUTC;
  indiceZona: number;

  userData:any;
  validationUser:boolean=false;
  validationSurvey:boolean=false;
  desbloqueoEstatus:boolean=false;
  nameUserAdmin:any="";
  nivelNotificacion:number;

  constructor(
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private dialog: MatDialog,
    private programacionService: ProgramacionService,
    private encuestaService: EncuestaService,
    private wizardService: WizardService,
    private wizardLeaderService: WizardLeaderService,
    private sheduleService: SheduleService,
    private surveyServ: SurveyStatusService,
    public authService: AuthService,
    private idiomasService: IdiomasService,
    private leaderEditService: LeaderEditEmaService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    this.programacionService.ordenProg.subscribe( (resu) => {
      console.log("se envio orden desde navbar: ",resu);
      this.logoOK = true;
      // if(this.logoOK && this.reqTecOK){
      //   this.cards[0].completo = true;
      // }
    });
    this.cards[0].completo = false;  //se desacompleta el paso 1 de seleccion de fecha

    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
      this.nameUserAdmin=this.userData.user;
    }
    else{
      this.validationUser=false;
      this.nameUserAdmin="";
    }
    }
  }

  ngOnInit() {
    this.obtieneCertificarActual();
    this.getBanderaUpdateFechaCierre();
    this.getProrrogasFechasCierre();
    this.getCierreActivo();
    // this.prerequisitos();
    setTimeout( () => {
      this.getFechaLanzamiento();
      this.getestatusSecciones();
      this.getEstatusEncuesta();
      console.log("se ejecutaron en segundo plano ");
    },2000);

  }

   getBanderaUpdateFechaCierre(){
     console.log(this.idEmpresa);
     console.log(this.idProducto);

     this.programacionService.getStatusBanderaProrroga(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
       console.log("respuesta:",respuesta);
      this.updateFechaCierre=respuesta.editarCierre;
      // if(this.updateFechaCierre){
        // this.cards[1].visible = true;
        // console.log(this.updateFechaCierre);
        // }
     });
   }

  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
  }

  cargaLogoEmpresa(){
    this.programacionService.enviaNavbar("hola prro");
  }

  reiniciarVariables(){
    this.secciones.forEach(seccion => {
      seccion.completo = false;
      seccion.fallo = false;
    });
    this.tamanioTagSecc = 0;
    this.progresoEncuesta = 0;
    this.procesoActual = "";
    this.procesoFinalizado = false;
    this.procesoOK = true;
  }

  traduceTextosTS(){
    // switch(this.translateSrv.currentLang){
    //   case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    //   default: this.idiomaActual = 'en';
    // }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  verFechas(){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '70%',
      data: {
        tipo: 'fechas',
        cierreEditable: this.cierreEditable,
        pasoCompleto: this.pasoCompleto,
        instituto: this.instituto
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(!this.cards[0].completo){
        if(result == undefined){
          this.cards[0].completo = false;
        }
        else{
          this.cards[0].completo = result.status;
          this.fechaLanzamiento = result.fechaLanzamiento;
          this.fechaCierre = result.fechaCierre;
          this.setFiltroRecordatorios();
          // this.cuentaRegresiva();
        }
      }
      else{
        if(result != undefined){
          this.fechaLanzamiento = result.fechaLanzamiento;
          this.fechaCierre = result.fechaCierre;
          this.setFiltroRecordatorios();
          // this.cuentaRegresiva();
        }
      }
    });
  }

  verProrrogas(){
    const dialogRef = this.dialog.open(ModalRecoComponent, {
      width: '50%',
      data: {
        tipo: 'prorrogas',
        prorrogas: this.prorrogasEncuesta,
        instituto: this.instituto
      }
    });
  }

  fechaSeleccionada(origen:number, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');

    if(origen == 1){
      console.log("Registra la fecha");
      // this.registerDate(date.getFullYear()+'-'+mnth+'-'+day);
      this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
    }
    else if(origen == 2){
      if(this.fechaLanzamiento){
        if(!this.fechasRecordatorios.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
          console.log("registra el recordatorio");
          //this.registerRecordatorio(date,date);
          this.guardaRecordatorio(fechaElegida);
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
      }
    }
  }

  registraFechaLanzamiento(fecha){
    console.log(fecha);

    const moment = require('moment');
    let data={
      productoId : localStorage.getItem('productoID'),
      fechaLanzamiento: fecha,
      accionText:'regisFechaLanza',
      userAdministrator:this.nameUserAdmin,
    };
    console.log("Data a registrar",data);

    let hoy = moment();
    let fechaElegida = moment(fecha);
    console.log("diferencia de dias",fechaElegida.diff(hoy,'days'));

    if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX' || localStorage.getItem('instituto') == '14' || localStorage.getItem('instituto') == 'GCTI'){
      if(fechaElegida.diff(hoy,'days') < 15){
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.LESSDAYS_T'),
          text: this.translateSrv.instant('SHEDULE.LESSDAYS_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
              text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
              icon: 'warning',
              showCancelButton: true,
reverseButtons: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
              cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
            }).then((result) => {
              if (result.value) {
                this.guardaFechaLanzamiento(data);
              }
            });
          }
        });
      }
      else{
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
          text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.guardaFechaLanzamiento(data);
          }
        });
      }
    }
    else{
      Swal.fire({
        title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
        text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          this.guardaFechaLanzamiento(data);
        }
      });
    }
  }

  guardaFechaLanzamiento(data:any){
    console.log("datosAGuardar:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVELAUNCHDATE'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.encuestaService.registerDate2(data).subscribe((respuesta:any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.message == '200'){
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        this.idFechaLanzamiento = respuesta.fechas._id;
        this.fechaLanzamiento = respuesta.fechas.fechaLanzamiento;
        this.filtroRecordatorios = (d: Date | null): boolean => {
          var moment = require('moment');
          const diaInicial = moment(this.fechaLanzamiento);
          const diaFinal = moment(this.fechaLanzamiento).add(21,'days');
          const diaActual = moment(d || new Date());
          return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
        };
        this.cards[0].completo = true;
        console.log("se volvio true cards 0 en guardaFecha");

        this.getFechaLanzamiento();
        this.enviaOrdenWizardNotificiaciones();

      }
      console.log("listaCards:",this.cards);
    }, error => {
      console.log(error);
    });

  }

  selRecordatorio(){
    if(this.fechaLanzamiento){
      if(this.fechasRecordatorios.length < this.recordatoriosPermitidos){
        this.calReco.open();
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }

  guardaRecordatorio(fecha){
    let moment = require('moment');
    this.fechaRecoTemp = moment(fecha).format('YYYY-MM-DD');
    $("#timepickerRecos").click();

  }
  horaSeleccionadaReco(event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaRecoTemp = this.fechaRecoTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.zonasUTC[this.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaRecoTemp,this.zonasUTC[this.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    let data={
      fechaRecordatorio: fechaTransformadaMasDifUtc.utc(true).toISOString(),
      accionText:'saveRecordatorioEncu',
      userAdministrator:this.nameUserAdmin,
      //encuestaId: localStorage.getItem('encuestaID')  //cuando se trata de focus area alv
    };
    console.log("datosRecoNuevo:",data);
    this.sheduleService.registerRecordatorioNuevo(data).subscribe((respuesta:any) => {
      console.log("guardaReco",respuesta);
      if(respuesta.message == '220'){
        this.openSnackBar(this.translateSrv.instant('SHEDULE.REMIDEROK'),this.translateSrv.instant('ALERTS.OK'));
        // this.fechasRecordatorios.push( this.alineaFechaUTC(data.fechaRecordatorio) );
        this.fechasRecordatorios.push( data.fechaRecordatorio );
        if(this.fechasRecordatorios.length == this.recordatoriosPermitidos){
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LASTRECO_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LASTRECO_2'), 2);
        }
        this.setFiltroRecordatorios();
        this.enviaOrdenWizardNotificiaciones();
      }
    }, error => {
    });

  }

  verRecordatorios(){
    if(this.fechaLanzamiento){
      const dialogRef = this.dialog.open(ModalRecoComponent, {
        width: '50%',
        data: {
          tipo: 'recordatorios',
          fechasRecordatorios: this.fechasRecordatorios,
          instituto: this.instituto
        }
      });
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.LISTARECOBEF'), 3);
    }
  }

  surveyCheckService(){
    if(this.token){
    this.programacionService.surveyCheck(this.token).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.datosSurveyCheck=respuesta.result;
      this.surveyCheck();
    }, error => {
    });
    }
  }

  surveyCheck(){
    const dialogRef = this.dialog.open(SurveyCheckComponent, {
      width: '40%',
      data: {
        datos: this.datosSurveyCheck
      }
    });
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.leaderEditService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.token=producto.tokenConfig;
              this.getStatusEncuesta(this.token);
              this.getEstatusDesbloqueo();
              // this.surveyCheckService();
              //obtiene el status del paso adicionales del certificar vigente
              this.leaderEditService.getStatusEmailEdit(localStorage.getItem('productoID')).subscribe( (data: backInter.getStatusIndiv) => {
                if(data.estatus === 3)
                  this.pasoCompleto = true;
              });
              this.idiomasService.getNivelNotificacionCatServ(this.instituto).subscribe( (data: any) => {
                console.log('entro get catalogo niveles notificaciones',data);
                this.nivelNotificacion=data.catlNotificationBroker[0].secciones.programacion.levelNotification;
                console.log('this.nivelNotificacion::',this.nivelNotificacion);
              });
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };

      this.getStatusModal();
      this.getInstituto();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoCertificar.idCertificar).subscribe((respuesta:any) => {
      console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  getStatusEncuesta(token:any){
    if(token){
      this.wizardService.getStatusEncuesta(token).subscribe( (data:any) => {
        // console.log(data);
        if(data.result.id_status==1){
          this.validationSurvey=true;
        }
        else{
          this.validationSurvey=false;
        }
      });
    }
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 1; break;
      case '2': case 'CAyC': this.instituto = 2; break;
      case '3': case 'HK': this.instituto = 3; break;
      case '4': case 'SGP': this.instituto = 4; break;
      case '5': case 'TK': this.instituto = 5; break;
      case '6': case 'FL': this.instituto = 6; break;
      case '11': case 'BR': this.instituto = 11; break;
      case '14': case 'GCTI': this.instituto = 14; break;
      case '15': case 'ES': this.instituto = 15; break;
    }
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instituto);
    this.filtraInstitutoVisible();
  }

  filtraInstitutoVisible(){
    let institutosPermitidos = [2,3,4,5,6,11,14,15];
    if(institutosPermitidos.includes(this.instituto)){
      // this.cards[1].visible = true;
      // this.cierreEditable = true;
    }
  }

  getStatusModal(){
    let datos={
      productoId: localStorage.getItem('productoID'),
      programacion: 1
    };
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
        this.modalInformativo('PROGRAMACION');
      }
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      inputValidator: (result)=>{
        return new Promise((resolve)=>{
          if (result){
            this.updateStatusModal();
          }
          resolve(result);
        });
      },

      confirmButtonText: rspSi,
      allowOutsideClick: false
    })
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      programacion: 2
    };
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  getCierreActivo(){
    this.programacionService.getCierreActivo(this.idEmpresa,this.idProducto).subscribe((respuesta:any) => {
      console.log("getCierreActivo:",respuesta);
      if(respuesta.success){
        this.recordatoriosPermitidos = respuesta.totalRecordatorios;
        this.cierreEditable = respuesta.actualizarFechaCierre;
      }
    });
  }

  getFechaLanzamiento(){
    let data:any = {
      productoId: localStorage.getItem('productoID')
    };
    let moment = require('moment');

    this.sheduleService.getFechaLanzamiento(data).subscribe((respuesta:any) => {
      console.log("respGetLanza",respuesta);
      if(respuesta.message == '200'){
        this.idFechaLanzamiento = respuesta.idFechaLanzamiento;
        this.fechaLanzamiento = respuesta.fechaLanzamiento;
        this.fechaCierre=respuesta.fechaCierre;
        this.fechaCierreValidacion=moment(this.fechaCierre).format('YYYY-MM-DD');
        this.setFiltroRecordatorios();
        this.cards[0].completo = true;
        // this.getAvisos();
        console.log("se volvio true cards 0 en getFechalanza");

        this.getRecordatorios();
        this.cuentaRegresiva();
      }
      console.log("listaCards:",this.cards);
    }, error => {
      //console.log(error);
    });
  }

  cuentaRegresiva(){
    let moment = require('moment');
    let fechaActual = moment();
    let fechaTransformadaMasDifUtc = moment(this.fechaLanzamiento);
    let diferencia = fechaActual.diff(fechaTransformadaMasDifUtc, 'seconds');
    // this.configCD.leftTime = diferencia;
    this.tiempoRestante = diferencia * -1;
    console.log("tiempoRestante:",this.tiempoRestante);
    // if(this.countdown){
    //   this.countdown.restart();
    //   this.countdown.begin();
    // }
  }

  getRecordatorios(){
    let moment = require('moment');
    let data: any = {
      productoId: localStorage.getItem('productoID')
    };
    this.sheduleService.getRecordatorios(data).subscribe((respuesta:any) => {
      console.log("respGetReco",respuesta);
      if(respuesta.message == '200'){
        respuesta.recordatoriosMostrar.forEach(recordatorio => {
          // this.fechasRecordatorios.push( this.alineaFechaUTC(recordatorio.fechaRecordatorio) );
          this.fechasRecordatorios.push( recordatorio.fechaRecordatorio );
        });
        console.log("fechasREcos:",this.fechasRecordatorios);

        this.setFiltroRecordatorios();
      }
    }, error => {
      console.log(error);
    });
  }

  alineaFechaUTC(fecha:string){
    var moment = require('moment');
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let fechaElegidaAjustada = moment.utc(fecha).add(diferenciaUtc, 'minutes');
    return fechaElegidaAjustada.format();
  }

  setFiltroRecordatorios(){
    this.filtroRecordatorios = (d: Date | null): boolean => {
      var moment = require('moment');
      var fecha = new Date(this.fechaLanzamiento.replace(/-/g, '\/').replace(/T.+/, ''));
      const diaInicial = moment(fecha);
      const diaFinal = moment(this.fechaCierre);
      const diaActual = moment(d || new Date());
      let esRecordatorio: boolean;
      let BreakException = {};
      try {
        this.fechasRecordatorios.forEach( (reco) => {
          if(moment(reco).utc(true).format('YYYY-MM-DD') == moment(d || new Date()).format('YYYY-MM-DD')){
            esRecordatorio = true;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal) && !esRecordatorio;
    };
  }

  getAvisos(){
    this.encuestaService.getAviso().subscribe((respuesta:any) => {
      console.log("getAviso:",respuesta);
      if(respuesta.success){
        if(respuesta.aviso1){
          this.cards[0].completo = true;
        }
        else if(!respuesta.aviso1){
          this.cards[0].completo = false;
        }
        if(respuesta.aviso2){
          this.cards[0].completo = true;
        }
        else if(!respuesta.aviso2){
          this.cards[0].completo = false;
        }
      }
      else{
        this.cards[0].completo = false;
      }
    });
  }

  getestatusSecciones(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.encuestaService.getStatusSecciones(data).subscribe((response:any) => {
      console.log("respGetSecc",response);
      this.secciones.forEach(seccion => {
        var BreakException = {};
        try {
          response.secciones.forEach( (seccionAgregada) => {
            if(seccion.id == seccionAgregada.nombre){
              seccion.visible = seccionAgregada.estatus;
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
      });
      console.log("Secciones Tras filtro:",this.secciones);

    }, error => {
      console.log(error);
    });
  }

  getEstatusEncuesta(){
    let data = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getEstatusEncuesta(data).subscribe((respuesta: backInter.getEstatusEncuesta) => {
      console.log("getStatEnc",respuesta);

      if(respuesta.success){
        if(respuesta.survey){
          this.procesoFinalizado = true;
          this.procesoOK = true;
          this.progresoEncuesta = 100;
          this.procesoActual = "SHEDULE2_0.SECCIONES.COMPLETA";
        }
        this.secciones.forEach(seccion => {
          seccion.completo = true;
          switch (seccion.id) {
            case 'NPS':
              seccion.visible = respuesta.nps;
            break;
            case 'Reactivos':
              seccion.visible = respuesta.reactivos;
            break;
            case 'Control':
              seccion.visible = respuesta.control;
            break;
            case 'Demograficos':
              seccion.visible = respuesta.demograficos;
            break;
            case 'Abiertas':
              seccion.visible = respuesta.abiertas;
            break;
            case 'Forall':
              seccion.visible = respuesta.forall;
            break;
            case 'Adicionales':
              seccion.visible = respuesta.adicionales;
            break;
          }
        });
      }
    }, error => {
      console.log(error);
    });
  }

  prerequisitos(){
    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.encuestaService.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {
      console.log("getPreReq",respuesta);
      if(respuesta.success){
        this.logoOK = respuesta.logo;
        this.reqTecOK = respuesta.requerimientos;
        if(this.logoOK && this.reqTecOK){
          this.cards[0].completo = true;
        }
      }
    }, error => {
      console.log(error);
    });
  }

  verSeccionesAgregadas(){
    this.creandoEncuesta = !this.creandoEncuesta;
  }

  completarPaso(){
    console.log("entro");
    if(this.pasoCompleto){
      //this.aletaRestric('PROGRAMACION.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ['background-red']
      });
    }else{
      // if(this.procesoFinalizado && this.procesoOK){
        this.aletaRestric('PROGRAMACION.COMPLETAR',true);
      // }
    }

  }
  enviaOrdenWizard(){
    this.wizardLeaderService.puenteDatosLeaderGo("100"); //100 = actualiza los status de los steps
  }

  desbloquearProgramacion(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.TITULO_DESBLOQUEAR2';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'DescompletePasProgra',
            productoId:this.productoCertificar.idCertificar,
            programacion: 2,
            userAdministrator:this.nameUserAdmin,
            actualizar: 1,
          }
          this.programacionService.DesbloquearPasoProgramacion(datos).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '215'){
               this.pasoCompleto = false;
               this.enviaOrdenWizard();
               this.openSnackBar(succes,"OK");
               /*Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,

               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,

        confirmButtonText: cerrar,
        })
      }
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'LEADER_GO.SECCION_PROGRAMACION.MODAL_CONFI_COMPL';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          let datos={
            accionText:'completePasProgra',
            productoId:this.productoCertificar.idCertificar,
            emailEdit: 3,
            userAdministrator:this.nameUserAdmin,
            actualizar: 1,

          }
          this.programacionService.guardaStatusProgramacion(datos).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '219'){
              //this.aletaRestric('PROGRAMACION.'+data.message,null,'success');
              // let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
              // this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
              // this.openSnackBar(textoMensaje,"OK");
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }

  updatefechaCierre(fecha){
    let texto = 'SHEDULE.WARNING_FECHA_UPDATE';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    let textoWarning = 'SHEDULE.FECHA_UPDATE_WARNING';
    let textoSuccess = 'SHEDULE.FECHA_UPDATE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    this.translateSrv.get(textoWarning).subscribe((res: string) => { textoWarning = res; });
    this.translateSrv.get(textoSuccess).subscribe((res: string) => { textoSuccess = res; });

    let moment = require('moment');
    let fechaActual=moment(fecha.value).format('YYYY-MM-DD');
    console.log(fechaActual);
    if (fechaActual < this.fechaCierreValidacion) {

      Swal.fire({
        icon: 'warning',
        text: texto,
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: rspSi,
      })
    }
    else{

      Swal.fire({
        title: textoWarning,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          let datos:any={} as backInter.updateFechaCierre;
          datos.productoId=localStorage.getItem('productoID');
          datos.empresaId=localStorage.getItem('companyID');
          datos.fecha=fechaActual;
          console.log(datos);

          this.programacionService.updateFechaCierreUsuarioEmpresa(datos).subscribe((data: any) => {
            console.log(data);
            if (data.success==true) {
              Swal.fire({
                icon: 'success',
                text: textoSuccess,
                showCancelButton: true,
reverseButtons: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: rspSi,
              })
              this.getFechaLanzamiento();
            }
          });
        }
      });
    }
  }


  getProrrogasFechasCierre(){
    this.surveyServ.getProrrogasFechaCierre(localStorage.getItem('productoID')).subscribe( (data: any) => {
      console.log("getProrrogasFechaCierre:",data);
      this.prorrogasEncuesta=data.result;
      if (this.prorrogasEncuesta.length>0) {
        this.prorrogas=true;
      }
    });

  }

  enviaOrdenWizardNotificiaciones(){
    // this.wizardService.puenteDatosNotificaciones("100"); //100 = actualiza los status de los steps
    let datos:any={actua:"100",nivelNotif: this.nivelNotificacion}
    this.authService.puenteDatosQuick(datos);
  }

}
